import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user from './user';
import hr from './hr';
import signUp from './sign-up';
import ui from './ui';
import lease from './lease';
import claim from './claim';
import budget from './budget';
import application from './application';
import docusign from './docusign';
import dashboard from './dashboard';
import settlement from './settlement';
import * as getters from './getters';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'ecx.novated',
  storage: window.localStorage,
  reducer: (state) => ({
    // Add fields that should be persisted
    ui: {
      hrApprovalsStatus: state.hr.hrApprovalsStatus
    },
    lease: {
      deliveryMessageShown: state.lease.deliveryMessageShown
    }
  })
});

export const structure = {
  modules: {
    user,
    signUp,
    hr,
    ui,
    application,
    docusign,
    dashboard,
    settlement,
    lease,
    claim,
    budget
  },
  getters
};

export default new Vuex.Store({
  ...structure,
  plugins: [vuexLocal.plugin]
});
